// extracted by mini-css-extract-plugin
export default {"tours":"cYh1wbVKUsWBpfl1RK0o","documentation":"TjydbKiIb5R0Y0e2FSi4","featureTours":"k7sNxG3lLC4VBf7nSryp","divider":"VCSIoE2A7fg_fvArl9B2"};